import { Button } from '@/components'
import { Dialog } from '@/components/UI/Dialog'
import dialogStyles from '@/components/UI/Dialog.module.css'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PointHistoryList } from './PointHistoryList'

export type PointHistoryEntry = {
  id: number | string
  label: string
  /** ポイント数。未指定のとき pt 列を表示しない（ポイントカードの獲得履歴用・#2970） */
  point?: number
  acquiredAt: string
  /** スタンプ名タップ時の遷移先スポット ID。null のときはタップ不可（#2972） */
  spotId: number | null
}

type Props = {
  items: PointHistoryEntry[]
  isOpen: boolean
  onClose: () => void
  /** ダイアログのタイトル。未指定時は「ポイント履歴」（既存動作） */
  title?: string
  /** スタンプ名タップ時に呼ばれる。spotId を渡す（#2972） */
  onSelectSpot?: (spotId: number) => void
}

/** ポイント履歴ダイアログ */
export const DialogPointHistory: FC<Props> = ({ items, isOpen, onClose, title, onSelectSpot }) => {
  const { t } = useTranslation()

  // DialogStampDetail の onCheckin と同じく、遷移を呼んでからダイアログを閉じる
  // （ページ遷移が完了するまでの間もダイアログを残さず、他の行の二重タップを防ぐ）
  const handleSelectSpot = onSelectSpot
    ? (spotId: number) => {
        onSelectSpot(spotId)
        onClose()
      }
    : undefined

  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={title ?? t('point_history.title', 'ポイント履歴')}>
      {/* タイトル〜リストの余白（24px）。タイトル上の24pxは Dialog header の paddingTop が担う */}
      <div className="mt-6">
        {/* scrollArea が Dialog body の padding を打ち消し、スクロールバーをダイアログ端に寄せる */}
        <div className={`${dialogStyles.scrollArea} max-h-[60vh]`}>
          <PointHistoryList items={items} onSelectSpot={handleSelectSpot} />
        </div>
        {/* リスト〜ボタンの余白（24px）。ボタン下の24pxは Dialog body の paddingBottom が担うため pb-* は付けない */}
        <div className="mt-6 w-full">
          <Button label="OK" variant={'primary'} size="md" fullWidth onClick={onClose} />
        </div>
      </div>
    </Dialog>
  )
}
